import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {RoutesModule} from './routes/routes.module';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {SidebarService} from './shared/services/sidebar.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ForgotComponent} from './forgot/forgot.component';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule} from '@angular/common/http';
import {AuthGuard} from './shared/services/auth-guard.service';
import {AuthTokenService} from './shared/services/auth-token.service';
import {ToasterModule, ToasterService} from 'angular5-toaster/dist';
import {AuthInterceptor} from './shared/services/auth-interceptor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommunicationService} from './shared/services/communication.service';
import {DxAutocompleteModule, DxChartModule, DxColorBoxModule, DxDateBoxModule, DxTemplateModule, DxPopupModule, DxScrollViewModule} from 'devextreme-angular';
import { TagCloudModule } from 'angular-tag-cloud-module';

@NgModule({
  declarations: [
    AppComponent,
    ForgotComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RoutesModule,
    BrowserAnimationsModule,
    ToasterModule,
    DxChartModule,
    DxDateBoxModule,
    DxTemplateModule,
    TagCloudModule,
    DxColorBoxModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxScrollViewModule,
  ],
  providers: [SidebarService, {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    AuthGuard, AuthTokenService, CommunicationService, ToasterService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts